module.exports = __webpack_public_path__ + "img/icon-trash-2.f4907e84.svg";